export default __webpack_public_path__ + "static/avenir-next-bold-dff81cbdc51c47475dd09c991579bbfd.ttf";